import { useState } from "react";
import { toast } from "sonner";
import { adminApi, errMsg } from "../../lib/api";
import { CATEGORIES } from "../../lib/format";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { ImageUpload } from "./ImageUpload";

const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Istanbul" });

export const AnnouncementForm = ({ item, onClose, onSaved }) => {
  const [f, setF] = useState({ title: item.title || "", content: item.content || "", category: item.category || "haber", image_path: item.image_path || "", date: item.date || today() });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (item.id) await adminApi.put(`/admin/announcements/${item.id}`, f);
      else await adminApi.post("/admin/announcements", f);
      toast.success("Kaydedildi");
      onSaved();
    } catch (er) {
      toast.error(errMsg(er));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-xl rounded-3xl max-h-[92vh] overflow-y-auto" data-testid="announcement-form-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">{item.id ? "Düzelt" : "Yeni Haber / Duyuru"}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-5">
          <div>
            <p className="text-sm font-bold text-slate-700 mb-2">1. Türü seçin</p>
            <div className="flex flex-wrap gap-2">
              {Object.entries(CATEGORIES).map(([k, v]) => (
                <button type="button" key={k} onClick={() => setF({ ...f, category: k })} data-testid={`form-category-${k}`}
                  className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${f.category === k ? "bg-[#1B4332] text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
                  {v.label}
                </button>
              ))}
            </div>
          </div>
          <label className="block">
            <span className="text-sm font-bold text-slate-700">2. Başlık</span>
            <Input required minLength={2} value={f.title} onChange={set("title")} className="mt-2 h-12 rounded-xl" placeholder="Örn: Su kesintisi duyurusu" data-testid="form-title-input" />
          </label>
          <label className="block">
            <span className="text-sm font-bold text-slate-700">3. Açıklama</span>
            <Textarea rows={6} value={f.content} onChange={set("content")} className="mt-2 rounded-xl" placeholder="Duyurunun detayını yazın" data-testid="form-content-input" />
          </label>
          <div>
            <p className="text-sm font-bold text-slate-700 mb-2">4. Resim (isteğe bağlı)</p>
            <ImageUpload value={f.image_path} onChange={(p) => setF({ ...f, image_path: p })} testid="form-image" />
          </div>
          <label className="block">
            <span className="text-sm font-bold text-slate-700">Tarih</span>
            <Input type="date" value={f.date} onChange={set("date")} className="mt-2 h-12 rounded-xl w-48" data-testid="form-date-input" />
          </label>
          <div className="flex gap-3 pt-2">
            <Button type="submit" disabled={busy} className="flex-1 h-12 rounded-full bg-[#1B4332] hover:bg-[#143326] font-bold text-base" data-testid="form-save-btn">
              {busy ? "Kaydediliyor..." : "Kaydet"}
            </Button>
            <Button type="button" variant="outline" onClick={onClose} className="h-12 rounded-full px-6" data-testid="form-cancel-btn">Vazgeç</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
